import { useState } from "react";
import { Link } from "react-router-dom";
import { Constants } from "../Constants";
import { StorageService } from "../services/StorageService";
import { useInitialFeedbackBannerState } from "../hooks/useInitialFeedbackBannerState";
import { theme } from "../styles/theme";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import StarPurple500RoundedIcon from "@mui/icons-material/StarPurple500Rounded";
import CloseIcon from "@mui/icons-material/Close";
import AlertTitle from "@mui/material/AlertTitle";
import { minutesToMilliseconds } from "../utils/ConvertTime";
import { useTranslation } from "react-i18next";
import { useFeedbackPageUrl } from "../hooks/useFeedbackPageUrl";

const FeedbackBanner = () => {
  const initialOpen = useInitialFeedbackBannerState();
  const feedbackUrl = useFeedbackPageUrl();

  const storageService = new StorageService();
  const [isOpen, setIsOpen] = useState(initialOpen);
  const { t } = useTranslation();

  const handleClose = () => {
    setIsOpen(false);
    storageService.set(
      Constants.storage.keys.feedbackBanner,
      JSON.stringify(false),
      minutesToMilliseconds(Constants.storage.expiry.feedbackBanner)
    );
  };

  return (
    <Collapse in={isOpen}>
      <Alert
        variant="feedback"
        severity="info"
        iconMapping={{
          info: <StarPurple500RoundedIcon fontSize="medium" />,
        }}
        action={
          <IconButton
            aria-label="close"
            sx={{
              color: theme.palette.common.black,
              padding: 0,
            }}
            size="small"
            onClick={() => {
              handleClose();
            }}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        <AlertTitle variant="feedback">
          {t(Constants.translationKeys.feedback_banner_title)}
        </AlertTitle>
        {t(Constants.translationKeys.feedback_banner_text_before_link)}
        <Link
          to={feedbackUrl}
          style={{ color: theme.palette.primary.main }}
          data-parentid="feedback-banner"
          data-id="feedback-banner-link"
        >
          {t(Constants.translationKeys.feedback_banner_link_text)}
        </Link>
        {t(Constants.translationKeys.feedback_banner_text_after_link)}
      </Alert>
    </Collapse>
  );
};

export default FeedbackBanner;
